// extracted by mini-css-extract-plugin
module.exports = {"btnPaginatorContainer":"paginator_btnPaginatorContainer__3P4jP","paginatorBtn":"paginator_paginatorBtn__1IGV9","currentPage":"paginator_currentPage__2LQMj"};